// ═══════════════════════════════════════════════════════════════
// V·IANet Governance — FlowMinimap (M3: V·IANet Flow)
// Capa 1C: Token-styled minimap with navy accents
// ═══════════════════════════════════════════════════════════════

import { MiniMap } from '@xyflow/react';
import { FLOW_TOKENS as T } from './flowTokens';
import type { FlowNodeData, TipoNodoFlujograma } from '../types/flowchart.types';

// ─── Special node types that use navy ────────────────────────────────────────

const NAVY_TYPES = new Set<TipoNodoFlujograma>(['INICIO', 'FIN', 'PROCESO_GOBIERNO', 'RESULTADO']);

function nodeColor(node: { data?: Record<string, unknown> }): string {
  const nodeType = (node.data as FlowNodeData | undefined)?.nodeType;
  if (nodeType && NAVY_TYPES.has(nodeType)) {
    return T.color.navy;
  }
  return T.color.nodeFill;
}

// ─── Component ───────────────────────────────────────────────────────────────

interface FlowMinimapProps {
  visible?: boolean;
}

export default function FlowMinimap({ visible = true }: FlowMinimapProps) {
  if (!visible) return null;

  return (
    <MiniMap
      position="bottom-right"
      nodeColor={nodeColor}
      maskColor="rgba(214, 228, 240, 0.35)"
      style={{
        borderRadius: 4,
        border: `1px solid ${T.color.border}`,
        background: 'rgba(255,255,255,0.9)',
      }}
      pannable
      zoomable
    />
  );
}
